import { render } from "./About.vue?vue&type=template&id=65eeb67a"
const script = {}

import "./About.vue?vue&type=style&index=0&id=65eeb67a&lang=scss"

import exportComponent from "/Users/patrikhubner/Dropbox/htdocs/Transmission/Data Storytelling Tool/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__